import { useStore } from "../../state/state.ts";
import Statistics from "../statistics.tsx";
export default function StatisticsRenovierungskosten() {
  const payback_period = useStore((state)=>state.payback_period);
  const total_planned_costs_from = useStore((state)=>state.total_planned_costs_from);
  const total_planned_costs_to = useStore((state)=>state.total_planned_costs_to);

  if (!total_planned_costs_from){return <></>}

  return (
    <Statistics label={"Sanierungkosten"} now={Math.round(total_planned_costs_from)+' - '+Math.round(total_planned_costs_to)} unit={!payback_period ? "€" : "€ (ROI "+payback_period+" Jahre)"} />
  )
}